import { createFileRoute } from "@tanstack/react-router";
import { salarySearchSchema } from "../-lib/search-schema";



export const Route = createFileRoute("/_protected/goals/salary/")({
  head: () => ({
    meta: [{ title: "工资管理 · imiker CRM" }],
  }),
  validateSearch: salarySearchSchema
});
